document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.collection__content'); // Boost product grid container
  if (!container) return;

  // Create Load More button
  const loadMoreButton = document.createElement('button');
  loadMoreButton.textContent = 'Load More Products';
  loadMoreButton.style.display = 'block';
  loadMoreButton.style.margin = '30px auto';
  loadMoreButton.style.padding = '12px 24px';
  loadMoreButton.style.fontSize = '16px';
  loadMoreButton.style.cursor = 'pointer';
  loadMoreButton.className = 'boost-load-more-button';

  // Insert button after product grid
  container.after(loadMoreButton);

  let loading = false;

  async function loadNextPage() {
    if (loading) return;

    const nextPageLink = document.querySelector('.pagination .next a'); // Boost next link
    if (!nextPageLink) {
      loadMoreButton.style.display = 'none'; // No more pages
      return;
    }

    loading = true;
    loadMoreButton.textContent = 'Loading...';

    try {
      const resp = await fetch(nextPageLink.href);
      const text = await resp.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Append new products
      const newProducts = doc.querySelectorAll('.collection__content .grid__item');
      newProducts.forEach(el => container.appendChild(el));

      // Update next page link
      const newNext = doc.querySelector('.pagination .next a');
      if (newNext) {
        nextPageLink.href = newNext.href;
        loadMoreButton.textContent = 'Load More Products';
      } else {
        loadMoreButton.style.display = 'none';
      }
    } catch (e) {
      console.error('Load More error:', e);
      loadMoreButton.textContent = 'Error! Try again';
    } finally {
      loading = false;
    }
  }

  loadMoreButton.addEventListener('click', loadNextPage);
});
